<!-- Heading -->
<mdb-card class="wow fadeIn">
    <!--Card content-->
    <mdb-card-body class="d-sm-flex justify-content-between ">
        <div style="display: contents;">
            <h5 class="mb-sm-0">
                <span>Trade History</span>
            </h5>
        </div>
    </mdb-card-body>

</mdb-card>

<!-- Heading -->
<mdb-card class="mb-4 mt-2 wow fadeIn">
    <!-- Card header -->
    <div class="card-header">
        <div class="row">
            <div class="md-form my-auto col-sm-12 col-md-3 col-lg-3">                
                    <select class="form-control browser-default" id="dateFilter" (change)="GetTradeHistory()"
                    [(ngModel)]="transactionSearchRequest.dateFilter" placeholder="Date range">
                        <option *ngFor="let date of DateFilter" [ngValue]="date.Id">{{date.Name}}</option>
                    </select>
                    <label for="dateFilter" class="active">Date range</label>                          
            </div>
            <div class="col-sm-12 col-md-3 col-lg-3">                
            </div>
            <div class="col-sm-12 col-md-6 col-lg-6">
                <button mdbBtn color="dooya-action" size="sm" class="my-0 p float-right" (click)="GetTradeHistory()">
                    Refresh
                </button>
                <button type="button" mdbBtn color="dooya-green" size="sm" (click)="Extract('UserTransactions')"
                    class="my-0 p float-right" mdbWavesEffect>
                    <mdb-icon fas icon="cloud-download-alt" class="mt-0"></mdb-icon> Extract
                </button>                
            </div>
        </div>    
    </div>
    <div class="card-header px-1">
        <div class="row mt-0">
            <div class="col py-1">
                <mdb-card>
                    <mdb-card-header class="p-2 text-center dooya-yellow">
                        <h6 class="small">Total Profit</h6>
                    </mdb-card-header>
                    <mdb-card-body class="p-1 text-center">
                    <p>R {{ totalProfit | number: "1.2-2" }}</p>
                    </mdb-card-body>
                </mdb-card>
            </div>
            <div class="col py-1">
                <mdb-card>
                    <mdb-card-header class="p-2 text-center dooya-green">
                        <h6 class="white-text small">Avg Trade Profit</h6>
                    </mdb-card-header>
                    <mdb-card-body class="p-1 text-center">
                    <p>R {{ averageTradeProfitZar | number: "1.2-2" }}</p>
                    </mdb-card-body>
                </mdb-card>
            </div>
            <div class="col py-1">
                <mdb-card>
                    <mdb-card-header class="p-2 text-center dooya-yellow">
                        <h6 class="small">Avg Profit Percentage</h6>
                    </mdb-card-header>
                    <mdb-card-body class="p-1 text-center">
                    <p>{{ averageProfitPercentage | number: "1.2-2" }}</p>
                    </mdb-card-body>
                </mdb-card>
            </div>
            <div class="col py-1">
                <mdb-card>
                    <mdb-card-header class="p-2 text-center dooya-green">
                        <h6 class="white-text small">Total Trades</h6>
                    </mdb-card-header>
                    <mdb-card-body class="p-1 text-center">
                    <p>{{ transactions.length }}</p>
                    </mdb-card-body>
                </mdb-card>
            </div>
            <div class="col py-1">
                <mdb-card>
                    <mdb-card-header class="p-2 text-center dooya-green">
                        <h6 class="white-text small">FIA Traded</h6>
                    </mdb-card-header>
                    <mdb-card-body class="p-1 text-center">
                    <p>R {{ totalFIAUsed | number: "1.0" }}</p>
                    </mdb-card-body>
                </mdb-card>
            </div>
            <div class="col py-1">
                <mdb-card>
                    <mdb-card-header class="p-2 text-center dooya-green">
                        <h6 class="white-text small">SDA Traded</h6>
                    </mdb-card-header>
                    <mdb-card-body class="p-1 text-center">
                    <p>R {{ totalSDAUsed | number: "1.0" }}</p>
                    </mdb-card-body>
                </mdb-card>
            </div>
            <div class="col py-1">
                <mdb-card>
                    <mdb-card-header class="p-2 text-center dooya-yellow">
                        <h6 class="small">Total Traded</h6>
                    </mdb-card-header>
                    <mdb-card-body class="p-1 text-center">
                    <p>R {{ totalTraded | number: "1.0" }}</p>
                    </mdb-card-body>
                </mdb-card>
            </div>
        </div>
    </div>

    <!--Card content-->
    <mdb-card-body class="col d-sm-flex justify-content-between">
        <div *ngIf="!busy && transactions.length > 0" class="table-responsive">
            <table mdbTable hover="true" id="UserTransactions">
                <thead>
                    <tr>
                        <th scope="col"> Profit</th>
                        <th scope="col"> Profit %</th>
                        <th scope="col"> Trade amount</th>
                        <th scope="col"> Start Date</th>
                        <th scope="col"> Completion Date</th>
                        <th scope="col"> SDA Amount</th>
                        <th scope="col"> FIA Amount</th>
                    </tr>
                </thead>
                <tbody mdbTableCol *ngFor="let trans of transactions">
                    <tr (click)="toggleFiaPinsTable(trans)">
                        <!--(click)="transactionDetail.show(); SelectTransaction(trans)"-->
                        <td *ngIf="trans.totalProfit>=0">
                            <mdb-icon size="lg" fas icon="angle-up dooya-green-text"></mdb-icon> R {{trans.totalProfit |
                            number}}
                        </td>
                        <td *ngIf="trans.totalProfit < 0">
                            <mdb-icon size="lg" fas icon="angle-down red-text"></mdb-icon> R {{trans.totalProfit |
                            number}}
                        </td>
                        <td>{{trans.totalProfitPercentage | number}}% </td>
                        <td>R {{trans.amountSent | number}}</td>
                        <td>{{trans.transactionStartDate | date}}</td>
                        <td>{{trans.GetTradeStatusOrCompletionDate()}}</td>
                        <td>R {{trans.sdaAmount | number}}</td>
                        <td>R {{trans.fiaAmount | number}}</td>
                    </tr>
                    <tr *ngIf="trans.transactionUserFiaPins.length > 0 && trans.selected" >
                        <td colspan="100%" style="border: 0 !important">
                            <table mdbTable colspan="100%" style="border: 0 !important">
                                <thead >
                                  <tr>
                                    <th scope="col">Pin</th>
                                    <th scope="col">Pin Amount</th>
                                    <th scope="col">Amount Used</th>
                                  </tr>
                                </thead>
                                <tbody *ngFor="let pin of trans.transactionUserFiaPins">
                                  <tr>
                                    <td>{{ pin.userFiaPin.pin }}</td>
                                    <td>{{ pin.userFiaPin.pinAmount }}</td>
                                    <td>{{ pin.amountUsed }}</td>
                                  </tr>
                                </tbody>
                              </table>
                        </td>                                        
                    </tr>
                </tbody>
            </table>
        </div>
        <ng-template #tradeAmountPopTemplate>Inc. R500 SWIFT fee</ng-template>

        <div class="w-100 text-center" *ngIf="!busy && transactions.length == 0"> 
            <img src="../../../../assets/img/Spreadsheet.svg" class="col-sm-3 mx-auto d-block" alt="1">
            <h2 class="text-center">We didn't find any trades...</h2>
            <p>We'll show the details of each trade here as soon as we get them.</p>
        </div>

        <!--Loading display-->
        <div *ngIf="busy" class="col-12 text-center">
            <app-loading [busy]="busy"></app-loading>
        </div>
    </mdb-card-body>

</mdb-card>
